module.exports = __webpack_public_path__ + "img/ico_xyfxyj.0efadd2c.png";